import { choseUnit } from 'utils/helperMethods';

export function promoScoreCardQuestionTable(data: any, promoType: any, promoQuestion: any, aggregatedItem: any) {
    let finalData: any = [];
    Object.keys(data)?.forEach((question: any, key) => {
        let tempArray: any[] = [];

        //when question is loading or when no data is present(when we get error in response)
        if (data[question]?.loading || data[question]?.data?.length === 0) {
            let obj: any = {};
            obj.Questions = promoQuestion.Q[key];
            obj.QuestionsData = promoQuestion.Q[key];
            obj.QuestionIndex = key;
            obj.italicsUnits = promoQuestion.unitsInItalics[key];
            obj.italicsUnitsData = promoQuestion.unitsInItalics[key];
            obj.tooltip = promoQuestion?.tooltips ? promoQuestion?.tooltips[key] : null; // if tooltip available access it
            obj.color = {};
            obj.name = '';
            obj.isExpandable = false;
            obj.nestedIndex = null;
            obj.loading = data[question]?.loading;
            obj.error = data[question]?.errorMessage;
            tempArray.push(obj);
            //when loading is done
        } else {
            data[question]?.data?.data?.forEach((attributeName: any, index: number) => {
                let obj: any = {};
                obj.Questions = index === 0 ? promoQuestion.Q[key] : '';
                obj.QuestionsData = promoQuestion.Q[key];
                obj.QuestionIndex = key;
                obj.italicsUnits = index === 0 ? promoQuestion.unitsInItalics[key] : '';
                obj.italicsUnitsData = promoQuestion.unitsInItalics[key];
                obj.tooltip = promoQuestion?.tooltips ? promoQuestion?.tooltips[key] : null;
                obj.color = {};
                obj.name = aggregatedItem?.string;
                obj.isExpandable = index === 0 ? data[question]?.data?.data?.length > 1 : false;
                obj.nestedIndex = index === 0 ? null : data[question]?.data?.data?.length > 1 ? finalData.length : null;

                obj.rowKey = `${key}-${attributeName?.attributeType}`;
                if (index !== 0) obj.name = attributeName?.attributeType;
                attributeName?.questionsData?.scoreData?.forEach((promoTypeValues: any, idx: number) => {
                    obj[promoType[idx]] = choseUnit(
                        promoQuestion.unit[key],
                        promoTypeValues?.score,
                        promoQuestion.numberFormateDecimal[key],
                    );
                });
                attributeName?.questionsData?.scoreData?.forEach((promoTypeValues: any, idx: number) => {
                    obj.color[promoType[idx]] = promoTypeValues.colorsData
                        ? `rgb(${promoTypeValues.colorsData?.R} ${promoTypeValues.colorsData?.G} ${promoTypeValues.colorsData?.B})`
                        : `rgba(255, 0, 0, 0)`;
                });
                obj.loading = data[question]?.loading;
                obj.error = data[question]?.errorMessage;
                tempArray.push(obj);
            });
        }

        finalData.push(...tempArray);
    });
    return finalData;
}
//
export function promoScoreCardExpendedTable(data: any, promoType: any, tableCol: any) {
    let finalData = data.map((row: any) => {
        let color: any = {};
        let promoTypeObj: any = {};
        row.questionsData.scoreData.forEach((promoTypeData: any, key: any) => {
            promoTypeObj[promoType[key]] = promoTypeData.score ? promoTypeData.score.toFixed(2) : '';
            color[promoType[key]] = promoTypeData.colorsData
                ? `rgb(${promoTypeData.colorsData.R} ${promoTypeData.colorsData.G} ${promoTypeData.colorsData.B})`
                : `rgba(255, 0, 0, 0)`;
        });
        let colorOfVol = row?.questionsData.salesValueData.colorsData;
        let colorOfSales = row?.questionsData.salesVolumeData.colorsData;
        color[tableCol[0]] = colorOfVol ? `rgb(${colorOfVol.R} ${colorOfVol.G} ${colorOfVol.B})` : `rgba(255, 0, 0, 0)`;
        color[tableCol[1]] = colorOfSales
            ? `rgb(${colorOfSales.R} ${colorOfSales.G} ${colorOfSales.B})`
            : `rgba(255, 0, 0, 0)`;
        return {
            PPG: row?.attributeType,
            [tableCol[0]]: row?.questionsData.salesVolumeData?.score?.toFixed(2),
            [tableCol[1]]: row?.questionsData.salesValueData?.score?.toFixed(2),
            ...promoTypeObj,
            color,
        };
    });
    return finalData;
}

// {
//     PPG: 'KIND PPG1',
//     'EQ Volume Lbs': 25000,
//     'Total Sales $': 25000,
//     TPR: 200,
//     Feature: 2000,
//     Display: 200,
//     'Feature & Display': 200,
//     color: {
//         'EQ Volume Lbs': colorConstants.orangeAlt,
//         'Total Sales $': colorConstants.red,
//         TPR: colorConstants.limeGreen,
//         Display: colorConstants.orangeAlt,
//         Feature: colorConstants.red,
//         'Feature & Display': colorConstants.limeGreen,
//     },
// },
